import type { ISessionRepository, SessionUpdateInput } from '../repositories/ISessionRepository.js';
import type { SessionEntity } from '../entities/SessionEntity.js';

export interface UpdateSessionInput { id: string; data: SessionUpdateInput; }
interface Deps { sessionRepository: ISessionRepository; }

export function createUpdateSessionUseCase({ sessionRepository }: Deps) {
  return async function updateSession({ id, data }: UpdateSessionInput): Promise<SessionEntity | null> {
    return sessionRepository.update(id, data);
  };
}
